import * as types from './types';

export default {
  [types.GET_FIRST_CARD]: state => state.firstCard,
};
